module.exports = __webpack_public_path__ + "ae11d17df8a4a55cd4c4a0d201f0f51a.png";